import { HashLink as Link } from "react-router-hash-link";

const Presence = () => {
  return (
    <section className="presence-section" id="presence">
      {/* <img src={require("../../assets/img/illu/illu01.webp")} alt="" /> */}
      <div className="illu-presence"></div>
      <article>
        <div className="presence-title">
          <h3>Présence Nationale</h3>
          <h2>
            UNE COUVERTURE
            <br /> SUR TOUT LE TERRITOIRE FRANÇAIS
          </h2>
          <h4 className="text-blue">
            Tribunaux de Commerce - Juge des Contentieux - Intervention locale
          </h4>
        </div>
        <p>
          Le cabinet LexiCredis intervient régulièrement sur l’ensemble du
          territoire français. Grâce à notre réseau étendu et notre expertise
          pointue, nous garantissons un service de proximité adapté aux réalités
          locales. <br />
          <br />
          Que vous soyez une institution régionale ou un grand groupe bancaire,
          nous avons la logistique et les compétences nécessaires pour vous
          défendre partout en France, avec la même rigueur et le même
          engagement.
        </p>
        <div className="btns">
          <Link to="/#services" className="btn-empty">
            Nos services
          </Link>
          <Link to="/#contact" className="btn-fill">
            Nous contacter
          </Link>
        </div>
        <div className="folder-shape">
          <div class="container">
            <div class="angled-shape"></div>
            <div class="rectangle"></div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default Presence;
